import { DraftOptionLeg } from '#/unified-rfqs/ui/rfq-builder/types';
import { UnifiedInstruments } from '#/unified-rfqs/ui/instruments/types';
import { areExpirationsEqual } from './expiration-utils';

export function greeksView(
  productCode: DraftOptionLeg['productCode'],
  optionKind: DraftOptionLeg['optionKind'],
  expiration: DraftOptionLeg['expiration'],
  strike: DraftOptionLeg['strike'],
  instruments: UnifiedInstruments['optionInstruments'],
) {
  const instrument = instruments.find(
    (ins) =>
      ins.product_code === productCode &&
      optionKind === ins.option_kind &&
      areExpirationsEqual(expiration, ins.expiration) &&
      strike === ins.strike,
  );
  return instrument?.greeks;
}
